import { useEffect, useState } from "react"
import { BasicPage } from "../../theme/Component/BasicPage"
import { _DocumentFactory, _single, _UBLInvoice } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { Modal } from "../../theme/Component/Modal"
import { BasicTable } from "../../theme/Component/BasicTable"
import { AccountEditor } from "../../editor/AccountEditor"
import usePaginator from "../../theme/Component/usePaginator"
import { YearSelector } from "../../../core/shared/inputs/YearSelector"
import { MonthConstantsEditor } from "../../RemoteAbstractAction/editors/MonthConstantsEditor"
import { SelectUBLDocumentTypeConstants } from "./Selectores/SelectUBLDocumentTypeConstants"
import { SelectDocumentStateConstants } from "./Selectores/SelectDocumentStateConstants"
import { MakeUBLInvoice } from "../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice"
import { BasicButton } from "../../theme/Component/BasicButton"
import useModal, { MODAL_SM, MODAL_XL } from "../../theme/Component/hooks/useModal"
import { SelectUBLAccountingDocumentTypes } from "./Selectores/SelectUBLAccountingDocumentTypes"
import { DocumentStorageEditor } from "../bodegaDocumentos/DocumentStorageEditor"
import { DropDown } from "../../theme/Component/DropDown"
import { ExportXLSL } from "../../theme/Component/ExportXLSX"
import { useUBLInvoiceActions } from "../../contract/etapa-contrato/contrac/ublinvoice/hooks/useUBLInvoiceActions";
import { CreateUBLInvoice } from "../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/CreateUBLInvoice";
import { CreateUBLInvoiceNote } from "../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/CreateUBLInvoiceNote";
import { UBLInvoiceSupplier } from "../../contract/etapa-contrato/contrac/UBLInvoiceSupplier/UBLInvoiceSupplier";

interface Form {
    IDAccountSupplier: number;
    IDAccountCustomer: number;
    UblDocumentType: number;
    Year: number;
    Month: number;
    State: number;
    DocumentYpe: string;
    IDDocument: number;
    DocumentDate: any;
}

export const UBLDocumentCatalog = () => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_UBLInvoice);
    const paginador = usePaginator();

    const [listaAll, setListaAll] = useState<any>([]);
    const [response, setResponse] = useState<Partial<Form>>({
        Year: _single.getCurrenYear(),
    });

    const [modalUBL, setModalUBL] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const modalXLS = useModal("Detallado", MODAL_SM);
    const modalEditInvoice = useModal("Editar Factura", MODAL_XL);


    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getLista = () => {
        instance.getUblInvoiceCatalog12(response.IDAccountSupplier, response.IDAccountCustomer, response.UblDocumentType, response.Year, response.Month, response.State, null, response.DocumentYpe, response.IDDocument, response.DocumentDate, paginador.page, 15).then(
            (resp) => {
                console.log(resp)
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Client = (user.DataBeanProperties.AccountCustomerNit ?? "") + "-" + (user.DataBeanProperties.AccountCustomerName ?? "");
                        user.DataBeanProperties.Doc = `${user.DataBeanProperties.FCIDDocument ? `${user.DataBeanProperties.FCMnemonic ?? ""} - ${user.DataBeanProperties.FCConsecutive ?? ""} - ${user.DataBeanProperties.FCDate ?? ""}` : "N/A"}`
                        user.DataBeanProperties.Remision = `${user.DataBeanProperties.EAFConsecutive ? `${user.DataBeanProperties.EAFMnemonic ?? ""} - ${user.DataBeanProperties.EAFConsecutive ?? ""} - ${user.DataBeanProperties.EAFDate ?? ""}` : "N/A"}`
                        user.DataBeanProperties.Obligation = `${user.DataBeanProperties.OBConsecutive ? `${user.DataBeanProperties.OBMnemonic ?? ""} - ${user.DataBeanProperties.OBConsecutive ?? ""} - ${user.DataBeanProperties.OBDate ?? ""}` : "N/A"}`
                        user.DataBeanProperties.DocRelation = `${user.DataBeanProperties.IDUBLInvoiceOwner ? `${user.DataBeanProperties.IDUBLInvoiceOwner ?? ""} - ${user.DataBeanProperties.IssueDateOwner ?? ""}` : "N/A"}`
                        user.DataBeanProperties.DocContigencia = `${user.DataBeanProperties.ContingencyDocReference ? `${user.DataBeanProperties.ContingencyDocReference ?? ""} - ${user.DataBeanProperties.ContingencyDocDate ?? ""}` : "N/A"}`
                    });
                    setLista(x)
                }
            }
        ).catch(err => { console.log(err) })
    }

    const getListaAll = () => {
        instance.getUblInvoiceCatalog12(response.IDAccountSupplier, response.IDAccountCustomer, response.UblDocumentType, response.Year, response.Month, response.State, null, response.DocumentYpe, response.IDDocument, response.DocumentDate, 1, (paginador.pages * 15) + 10).then(
            (resp) => {
                console.log(resp)
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    let x = resp.List;
                    x.forEach((user) => {
                         user.DataBeanProperties.Client = (user.DataBeanProperties.AccountCustomerNit ?? "") + "-" + (user.DataBeanProperties.AccountCustomerName ?? "");
                        user.DataBeanProperties.Doc = `${user.DataBeanProperties.FCIDDocument ? `${user.DataBeanProperties.FCMnemonic ?? ""} - ${user.DataBeanProperties.FCConsecutive ?? ""} - ${user.DataBeanProperties.FCDate ?? ""}` : "N/A"}`
                        user.DataBeanProperties.Remision = `${user.DataBeanProperties.EAFConsecutive ? `${user.DataBeanProperties.EAFMnemonic ?? ""} - ${user.DataBeanProperties.EAFConsecutive ?? ""} - ${user.DataBeanProperties.EAFDate ?? ""}` : "N/A"}`
                        user.DataBeanProperties.Obligation = `${user.DataBeanProperties.OBConsecutive ? `${user.DataBeanProperties.OBMnemonic ?? ""} - ${user.DataBeanProperties.OBConsecutive ?? ""} - ${user.DataBeanProperties.OBDate ?? ""}` : "N/A"}`
                        user.DataBeanProperties.DocRelation = `${user.DataBeanProperties.IDUBLInvoiceOwner ? `${user.DataBeanProperties.IDUBLInvoiceOwner ?? ""} - ${user.DataBeanProperties.IssueDateOwner ?? ""}` : "N/A"}`
                        user.DataBeanProperties.DocContigencia = `${user.DataBeanProperties.ContingencyDocReference ? `${user.DataBeanProperties.ContingencyDocReference ?? ""} - ${user.DataBeanProperties.ContingencyDocDate ?? ""}` : "N/A"}`
                    });
                    setListaAll(x)
                }
            }
        ).catch(err => { console.log(err) })
    }

    const actionsDropDown = [
        { id: 1, name: 'Descargar Reporte', permiso: null, activo: lista.length > 0 },

    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {

                            modalXLS.open();
                            getListaAll();

                        }

                    }}></DropDown>
                </div>
            </div>
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: (_single.canCreate() && response.Year), icono: 'ri-file-add-line', evento: () => { setModalUBL({ ...modalUBL, "view": true, "name": "Agregar Factura Electronica" }) } }
    ]

    const update = () => {
        setModalUBL({ ...modalUBL, "view": false });
        getLista();
    }

    const normalizeText = (value: string) => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    const openEditInvoice = () => {
        const typeName = normalizeText(bean?.UBLDocumentTypeName ?? "factura");
        modalEditInvoice.setModal((prev: any) => ({
            ...prev,
            btnSubmit: false,
            name: `Editar ${typeName || "Factura"}`,
            format: MODAL_XL,
        }));
        modalEditInvoice.open();
    }

    const closeEditInvoice = () => {
        modalEditInvoice.close();
        getLista();
    }

    const renderEditInvoiceForm = () => {
        const documentType = Number(bean?.UBLDocumentType);
        const typeName = normalizeText(bean?.UBLDocumentTypeName ?? "");

        if (!bean?.IDUBLInvoice) return null;

        if (documentType === 0) {
            return <UBLInvoiceSupplier embedded initialInvoice={bean} onSaved={closeEditInvoice} />
        }

        if (documentType === 2 || typeName.includes("credito")) {
            return <CreateUBLInvoiceNote embedded entry="Credit" initialInvoice={bean} onSaved={closeEditInvoice} />
        }

        if (documentType === 3 || typeName.includes("debito")) {
            return <CreateUBLInvoiceNote embedded entry="Debit" initialInvoice={bean} onSaved={closeEditInvoice} />
        }

        return <CreateUBLInvoice embedded typeDocument="sell" initialInvoice={bean} onSaved={closeEditInvoice} />
    }

    const { listButtons: ublInvoiceActionButtons, actionModals: ublInvoiceActionModals, head: ublInvoiceHead } = useUBLInvoiceActions({
        invoice: bean,
        canView: _single.canView(),
        canDelete: _single.canDelete(),
        onChange: () => { getLista() },
        onEdit: openEditInvoice,
    });

    return (
        <BasicPage titulo="Catálogo de Documentos UBL">
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor idAccount={response.IDAccountSupplier} label="Proveedor" onChange={(e) => { setResponse({ ...response, "IDAccountSupplier": e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={response.IDAccountCustomer} label="Cliente" onChange={(e) => { setResponse({ ...response, "IDAccountCustomer": e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <SelectUBLDocumentTypeConstants idSelect={response.UblDocumentType} onChange={(e) => { setResponse({ ...response, "UblDocumentType": e }) }} label="Tipo de Documento" />
                </div>
                <div className="col-md-6">
                    <YearSelector value={response.Year} onChange={(e) => { setResponse({ ...response, "Year": e }) }} tittle="Vigencia" />
                </div>
                <div className="col-md-6">
                    <MonthConstantsEditor idSelect={response.Month} onChange={(e) => { setResponse({ ...response, "Month": e }) }} label="Mes" name="Month" />
                </div>
                <div className="col-md-6">
                    <SelectDocumentStateConstants idSelect={response.State} onChange={(e) => { setResponse({ ...response, "State": e }) }} label="Estado" />
                </div>
                <div className="col-md-6">
                    <SelectUBLAccountingDocumentTypes idSelect={response.DocumentYpe} onChange={(e) => { setResponse({ ...response, DocumentYpe: e }) }} label="Tipo Documento Contable" />
                </div>
                <div className="col-md-6">
                    <DocumentStorageEditor label="Selector de Documentos" mNemonic={response.DocumentYpe} onChange={(e) => { setResponse({ ...response, IDDocument: e.IDDocument, DocumentDate: e.DocumentDate }) }} />
                </div>

            </div>
            <div className="row mt-4">
                <div className="col-md-4">
                    <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={"Buscar"} />
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <BasicTable
                        iconButtons={iconButtonsItem}
                        listButtons={ublInvoiceActionButtons}
                        headButtons={buttons()}
                        head={ublInvoiceHead}
                        body={lista}
                        rowSet={setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />
                </div>
            </div>
            {ublInvoiceActionModals}
            <Modal modal={modalEditInvoice.modal} updateModal={modalEditInvoice.setModal}>
                {renderEditInvoiceForm()}
            </Modal>
            <Modal modal={modalXLS.modal} updateModal={modalXLS.setModal}>
                <ExportXLSL customName={`UBL_${_single.getRandomInt()}`} optionIcon="ri-download-cloud-2-line text-success" title={ublInvoiceHead} data={listaAll} onExport={(name: string) => {
                    _single.download("formato xlsx [" + name + "] con " + listaAll.length + " registros");
                    modalXLS.close();
                }} />
            </Modal>

            <Modal modal={modalUBL} updateModal={setModalUBL} 
                // eventModal={() => { update() }} 
                evenOnClose={getLista} >
                <MakeUBLInvoice catalog _onChange={(e) => { console.log(e) }} />
            </Modal>
            
        </BasicPage>
    )
}
